<template>
	<div id="modal-common-bulk-edit">
		<b-modal :id="modalName" hide-footer>
            <template v-slot:modal-title>
                Bulk Edit
            </template>

            <b-button type="submit" variant="success" @click="exportColumns">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Exporting...
                </span>
                <span v-else>Update</span>
            </b-button>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'fields',
            'ignores',
            'table'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-common-bulk-edit',
                submitting: 0,
                colTypes: {

                }
			}
		},

		methods: {
            exportColumns() {
                let cols = []
                let keys = []
                this.fields.forEach(key => {
                    if (key.visible && !this.ignores.includes(key.key)) {
                        cols.push(key.label)
                        keys.push(key.key)
                    }
                })

                this.closeModal(this.modalName)
                this.$emit('exportExcel', cols, keys)
            }
		},

		computed: {

		},

		mounted() {

		}
	}
</script>
<style lang="scss">
    #modal-common-bulk-edit {
        .modal-dialog {
            width: 250px;
        }
    }
</style>
